// extracted by mini-css-extract-plugin
module.exports = {"button":"_927a99ad28--button--_uv0B"};